module.exports = "/images/vendor/flag-icon-css/flags/4x3/gb.svg?710a19d3e160ca459675f07e3c787e95";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/gb.svg
// module id = /PXy
// module chunks = 66